module.exports = __webpack_public_path__ + "fonts/22283bde2e26e11153a75ff47c6814cb.txt";